var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2901 11.9999L14.8301 8.45995C15.0163 8.27259 15.1209 8.01913 15.1209 7.75495C15.1209 7.49076 15.0163 7.23731 14.8301 7.04995C14.7371 6.95622 14.6265 6.88183 14.5046 6.83106C14.3828 6.78029 14.2521 6.75415 14.1201 6.75415C13.9881 6.75415 13.8573 6.78029 13.7355 6.83106C13.6136 6.88183 13.503 6.95622 13.4101 7.04995L9.17007 11.2899C9.07634 11.3829 9.00194 11.4935 8.95117 11.6154C8.90041 11.7372 8.87427 11.8679 8.87427 11.9999C8.87427 12.132 8.90041 12.2627 8.95117 12.3845C9.00194 12.5064 9.07634 12.617 9.17007 12.7099L13.4101 16.9999C13.5035 17.0926 13.6143 17.166 13.7362 17.2157C13.858 17.2655 13.9885 17.2907 14.1201 17.2899C14.2517 17.2907 14.3821 17.2655 14.504 17.2157C14.6258 17.166 14.7366 17.0926 14.8301 16.9999C15.0163 16.8126 15.1209 16.5591 15.1209 16.2949C15.1209 16.0308 15.0163 15.7773 14.8301 15.5899L11.2901 11.9999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.acf19d6b0dbf95912063dd0da6c2cf5b.svg";
export { ForwardRef as ReactComponent };